var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"health-prod-types",on:{"click":_vm.typeClick}},[_c('div',[_c('img',{attrs:{"src":require('../../assets/' + _vm.ht.imgName + '.jpg'),"alt":"ht.imgName"}}),_c('h4',{staticClass:"name"},[_vm._v(_vm._s(_vm.ht.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }